/* eslint-disable no-unused-vars */
import {
  Button,
  Col,
  DatePicker,
  Input,
  Modal,
  Row,
  Table,
  Typography,
  notification,
} from "antd";

import React, { useEffect, useRef, useState } from "react";
import { Panel, PanelBody, PanelHeader } from "../../../util/panel";
import moment from "moment";
import SelectOption from "../../pos/components/SelectOption";
import { useHttp } from "../../../../hooks/http";
import { getToken, URL_API } from "../../../../utils";
import { FaCog, FaHistory, FaLock, FaPlus } from "react-icons/fa";
import History from "./component/history";
import ReserveModal from "./component/reserveModal";
import UnlockModal from "./component/unlockModal";

const { Text } = Typography;
const { Search } = Input;
const limit = 30;
const pageSize = 20;

const Index = () => {
  const [memberTypeFilter, setMemberTypeFilter] = useState("");
  const [page, setPage] = useState(1);
  const [date_from, setDateFrom] = useState(moment());
  const [date_to, setDateTo] = useState(moment());
  const [search, setSearch] = useState("");
  const [historyOpen, setHistoryOpen] = useState(false);
  const [openReserveModal, setOpenReserveModal] = useState(false);
  const [openUnlockModal, setOpenUnlockModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const memberTypeOptions = [
    { value: "", text: "สมาชิกทั้งหมด" },
    { value: "Distributor", text: "นักธุรกิจ" },
    { value: "Member", text: "VIP MEMBER" },
  ];

  const [loading, data, error, reload] = useHttp(
    {
      url: `${URL_API}/point/rp/reserve-list`,
      token: true,
      params: {
        limit,
        offset: limit * (page - 1),
        query: search,
        date_from: date_from ? moment(date_from).format("YYYY-MM-DD") : null,
        date_to: date_to ? moment(date_to).format("YYYY-MM-DD") : null,
        member_type_filter: memberTypeFilter,
      },
      initialLoad: true,
    },
    [search, date_from, date_to, memberTypeFilter]
  );

  return (
    <Panel>
      <PanelHeader>จองคะแนน</PanelHeader>
      <PanelBody>
        <Row gutter={12} type="flex" className="align-items-center mb-3">
          <Col span={10}>
            <Search
              placeholder="ค้นหาจาก รหัสสมาชิก"
              onSearch={(value) => setSearch(value)}
              allowClear
            />
          </Col>
          <Col span={2} className="text-right">
            <Text strong>ประเภทสมาชิก</Text>
          </Col>
          <Col span={4}>
            <SelectOption
              className="w-100"
              defaultValue={memberTypeFilter}
              options={memberTypeOptions}
              onChange={(e) => setMemberTypeFilter(e)}
            />
          </Col>
          <Col span={2} className="text-right">
            <Typography.Text strong className="text-nowrap">
              วันที่ดำเนินการ
            </Typography.Text>
          </Col>
          <Col span={6}>
            <DatePicker.RangePicker
              className="w-100"
              placeholder={["วันที่เริ่มต้น", "วันที่สิ้นสุด"]}
              format="DD/MM/YYYY"
              value={[date_from, date_to]}
              onChange={(e) => {
                setDateFrom(e[0] ? moment(e[0], "DD/MM/YYYY") : null);
                setDateTo(e[1] ? moment(e[1], "DD/MM/YYYY") : null);
              }}
            />
          </Col>
        </Row>
        <Row
          gutter={12}
          type="flex"
          className="align-items-center mb-3"
          justify="end"
        >
          <Col span={2}>
            <Button
              block
              //type=""
              onClick={() => setHistoryOpen(true)}
            >
              <FaHistory className="mr-2" />
              ประวัติ
            </Button>
          </Col>
          <Col span={2}>
            <Button
              block
              type="primary"
              onClick={() => setOpenReserveModal(true)}
            >
              <FaPlus className="mr-2" />
              จองคะแนน
            </Button>
          </Col>
        </Row>

        <Table
          bordered
          size="small"
          dataSource={data?.data.length > 0 ? data?.data : []}
          rowKey="row_id"
          loading={loading}
          scroll={{ x: "max-content" }}
          pagination={{
            current: page,
            pageSize: limit,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} จากทั้งหมด ${total} รายการ`,
            total: data?.data.length,
            showLessItems: true,
            size: "default",
            onChange: (currPage) => setPage(currPage),
          }}
        >
          <Table.Column title="#" dataIndex="row_id" align="left" />
          <Table.Column
            title="วันที่ทำการ"
            dataIndex="document_date"
            align="left"
            render={(text) =>
              text ? moment(text).format("DD/MM/YYYY HH:mm") : "-"
            }
          />
          <Table.Column
            title="รหัสสมาชิก"
            dataIndex="partner_code"
            align="left"
          />

          <Table.Column
            title="ชื่อ - นามสกุล"
            dataIndex="partner_name"
            align="left"
          />
          <Table.Column
            title="คะแนนที่ใช้"
            dataIndex="point"
            align="left"
            render={(text) => {
              const value = Math.abs(Number(text)) || 0;
              return (
                <div style={{ textAlign: "right" }}>
                  {value.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </div>
              );
            }}
            onCell={() => ({
              style: { textAlign: "right" },
            })}
          />

          <Table.Column
            title="รายละเอียด"
            dataIndex="description"
            onCell={() => ({
              style: {
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                maxWidth: 300,
                textAlign: "left",
              },
            })}
            align="center"
          />
          <Table.Column
            title={<FaCog />}
            dataIndex="id"
            align="center"
            className="f-s-12"
            onCell={() => ({
              style: { maxWidth: 100, textAlign: "center" },
            })}
            render={(id, record) => (
              <Button
                block
                type="primary"
                onClick={() => {
                  setSelectedRecord(record);
                  setOpenUnlockModal(true);
                }}
              >
                <FaLock className="mr-2" />
                ปลดล็อก
              </Button>
            )}
          />
        </Table>
        <Modal
          visible={historyOpen}
          onCancel={() => setHistoryOpen(false)}
          width="80%"
          zIndex={1080}
          footer={null}
          maskClosable={false} // ไม่ปิดเมื่อคลิกด้านนอก
          keyboard={false} // ไม่ปิดเมื่อกด Esc
          bodyStyle={{ paddingTop: "54px" }}
        >
          {historyOpen && <History key={Date.now()} />}
          <div style={{ textAlign: "right", marginTop: 8 }}>
            <Button type="primary" onClick={() => setHistoryOpen(false)}>
              ปิด
            </Button>
          </div>
        </Modal>

        <ReserveModal
          visible={openReserveModal}
          onCancel={() => {
            setOpenReserveModal(false);
          }}
          onSuccess={() => {
            reload();
            setOpenReserveModal(false);
          }}
        />
        <UnlockModal
          visible={openUnlockModal}
          record={selectedRecord}
          onCancel={() => {
            setOpenUnlockModal(false);
            setSelectedRecord(null);
          }}
           onSuccess={() => {
            setSelectedRecord(null);
            setOpenUnlockModal(false);
            reload();
          }}
        />
      </PanelBody>
    </Panel>
  );
};

export default Index;
